export default __webpack_public_path__ + "static/media/ltr-gp-img.07a9844a.webp";